export default "//static.tradera.net/touchweb/static/output/images/mao-feature-modal-active-3x.4ddc0654.png";